import App from "./App";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import "./styles/full.css";


const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
